"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useCulture = require("./useCulture");
Object.keys(_useCulture).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useCulture[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useCulture[key];
    }
  });
});
var _useFormatBp = require("./useFormatBp");
Object.keys(_useFormatBp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useFormatBp[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useFormatBp[key];
    }
  });
});
var _useFormatCurrency = require("./useFormatCurrency");
Object.keys(_useFormatCurrency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useFormatCurrency[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useFormatCurrency[key];
    }
  });
});
var _useFormatDate = require("./useFormatDate");
Object.keys(_useFormatDate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useFormatDate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useFormatDate[key];
    }
  });
});
var _useFormatNumber = require("./useFormatNumber");
Object.keys(_useFormatNumber).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useFormatNumber[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useFormatNumber[key];
    }
  });
});
var _useFormatPercent = require("./useFormatPercent");
Object.keys(_useFormatPercent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useFormatPercent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useFormatPercent[key];
    }
  });
});
var _useFormatPoints = require("./useFormatPoints");
Object.keys(_useFormatPoints).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useFormatPoints[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useFormatPoints[key];
    }
  });
});
//# sourceMappingURL=index.js.map